import React, { useRef, useEffect } from "react";
import "./style.scss";
import Comps from "components/index";
import { getScreenShots } from "@/utils";
const { LargeBanner, PromotionTip } = Comps;
const IndexPage = props => {
  const page1Ref = useRef();
  const screenShotSrc = (node, options, encoderOptions) => {
    if (window.screenSrc) {
      return Promise.resolve(window.screenSrc);
    } else {
      return getScreenShots(node, options, encoderOptions).then(src => {
        window.screenSrc = src;
        return src;
      });
    }
  };
  useEffect(() => {
    window.JsBridge.xfpyappH5Js.off("getFirstpageImg");
    setTimeout(() => {
        screenShotSrc(
          page1Ref.current.parentNode,
          {
            width: window.innerWidth,
            height: window.innerWidth * 604 / 375, //(375 * window.innerHeight) / window.innerWidth,
            scale: 1
          },
          1
        );
    }, 3000);
    window.JsBridge.xfpyappH5Js.on("getFirstpageImg", ex => {
      console.info("native call getFirstpageImg", ex);
      screenShotSrc(
        page1Ref.current.parentNode,
        {
          width: window.innerWidth,
          height: window.innerWidth * 604 / 375, //(375 * window.innerHeight) / window.innerWidth,
          scale: 1
        },
        1
      )
        .then(src => {
          console.info("js call native saveFirstpageImg", src);
          window.JsBridge.xfpyappJsBridge.saveFirstpageImg(src, "{}");
        })
        .catch(e => {
          window.JsBridge.xfpyappJsBridge.toast("获取首屏图片失败");
        });
    });
  }, [page1Ref]);

  return (
    <div ref={page1Ref} className="page-slide idx1-page">
      <LargeBanner className="center-banner-wrapper"></LargeBanner>
      <PromotionTip className="tip-wrapper"></PromotionTip>
      <div className="bottom-icon-circle"></div>
    </div>
  );
};
export default IndexPage;
